export const GRAPHQL_VARIABLES = {
  record: {
    email: 'john.sun@bookipi.com',
    phone: '0123213123',
    firstName: 'John',
    lastName: 'Sun',
    companyName: "John's Company",
    address: {
      address1: 'line1',
      address2: 'line2',
      address3: '',
      state: 'NSW',
      city: 'Sydney',
      zip: '2020',
      country: 'Australia'
    }
  }
};

export const QUERY = `
  mutation vendorsCreateOne ($record: AutoFilledCreateOnevendorsInput!) {
    vendorsCreateOne (record: $record) {
        recordId
        record {
            email
            phone
            firstName
            lastName
            companyName
            address {
                address1
                address2
                address3
                state
                city
                zip
                country
                _id
            }
            companyId
            bpCompany
            _id
            updatedAt
            createdAt
        }
        error {
            message
        }
    }
  }
`;
